var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "performance" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _vm.theme == "blue" || _vm.theme == "yellow"
        ? _c(
            "div",
            {
              staticClass: "cards-blue",
              style:
                _vm.prHitData.length == 3 || _vm.prHitData.length == 5
                  ? ""
                  : "justify-content: center;",
            },
            _vm._l(_vm.prHitData, function (item, index) {
              return _c("div", { key: index, staticClass: "card-blue" }, [
                _c("div", { staticClass: "number" }, [
                  index < 9
                    ? _c("span", [_vm._v("0" + _vm._s(index + 1))])
                    : _c("span", [_vm._v(_vm._s(index + 1))]),
                ]),
                _c(
                  "div",
                  { class: [_vm.language === "zh" ? "zh_text" : "en_text"] },
                  [_vm._v(_vm._s(item.content))]
                ),
              ])
            }),
            0
          )
        : _c(
            "div",
            {
              staticClass: "cards",
              style:
                _vm.prHitData.length == 3 || _vm.prHitData.length == 5
                  ? ""
                  : "justify-content: center;",
            },
            _vm._l(_vm.prHitData, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "card", class: "card" + index },
                [
                  _c("div", { staticClass: "index" }, [
                    index < 9
                      ? _c("span", [_vm._v("0" + _vm._s(index + 1))])
                      : _c("span", [_vm._v(_vm._s(index + 1))]),
                  ]),
                  _c(
                    "div",
                    { class: [_vm.language === "zh" ? "zh_text" : "en_text"] },
                    [_vm._v(_vm._s(item.content))]
                  ),
                ]
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }